export const cleanResumeText = (value) => {
  if (value === null || value === undefined) return '';
  return String(value).replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
};

export const normalizeResumeBulletLines = (items = []) => {
  const values = Array.isArray(items) ? items : [items];
  return values.flatMap((value) => {
    if (value === null || value === undefined) return [];
    const text = String(value)
      .replace(/<[^>]*>/g, '')
      .replace(/\r\n/g, '\n')
      .replace(/\r/g, '\n')
      .replace(/(?:^|\n)\s*[-*]\s+/g, '\n• ');

    return text
      .split(/[•●▪◦‣]+|\n+/)
      .map((part) => cleanResumeText(part).replace(/^[\s\-*]+/, '').trim())
      .filter(Boolean);
  });
};
